module.exports = __webpack_public_path__ + "img/bg-magento-find-out.477e9481.jpg";